export type Listener<T> = (data: T) => void;

export class Stream<T> {
  private listeners: Set<Listener<T>> = new Set();

  public on(listener: Listener<T>): () => void {
    this.listeners.add(listener);

    return () => this.off(listener);
  }

  public off(listener: Listener<T>): void {
    this.listeners.delete(listener);
  }

  public emit(data: T): void {
    this.listeners.forEach((listener) => listener(data));
  }
}
